import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Dropdown } from "primereact/dropdown"
import { InputText } from 'primereact/inputtext'

import ksa from "assets/images/flag_placeholder.png"
import './style.scss'
import { classNames } from 'primereact/utils'

function MobileNumber({
  name = '',
  options = [{ name: "+966", code: "ksa" }],
  onChange = () => { },
  error = '',
  translation = true,
  value = '',
  maxLength = 9,
  inputMode = 'numeric',
  number = true
}) {
  const { t, i18n } = useTranslation()
  const [selectedCode, setSelectedCode] = useState(+966)
  const currentLanguageCode = i18n.language;
  const selectedCountryTemplate = (option, props) => {
    if (option) {
      return (
        <div className="country-item country-item-value">
          <img alt={option.name} src={ksa} className={`flag flag-${option.code.toLowerCase()}`} />
          <span className='isEnglish'>{option.name}</span>
        </div>
      );
    }
    return (
      <div className="country-item country-item-value">
        <img alt="ksa" src={ksa} className={`flag flag-ksa`} />
        <span>{props.placeholder}</span>
      </div>
    )
  }
  const countryOptionTemplate = (option) => {
    return (
      <div className="country-item">
        <img alt={option.name} src={ksa} className={`flag flag-${option.code.toLowerCase()}`} />
        <span>{option.name}</span>
      </div>
    )
  }

  return (
    <div className="common_mobile_number">
      <div className={classNames({
              "common_mobile_number_wrapper": true,
              "p-invalid": Boolean(error.length),
            })}>
        <span className={`numPos ${currentLanguageCode === 'ar' ? "posRight" : ""}`}>{t("HomeInsurnace.phoneNo")}</span>
        <span className="code mx-3">
          +966
        </span>
        <InputText
          name={name}
          value={value}
          maxLength={maxLength}
          onChange={e => onChange({ ...e, number })}
          placeholder={t("PERSONAL_DETAIL.EX")}
          inputMode={inputMode}
          className={"isEnglish"}
          pattern="[0-9]*"
        />
      </div>
      {Boolean(error.length) && (
        <small className="p-error block">{translation ? t(error) : error}</small>
      )}
    </div>
  )
}

export default MobileNumber